import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { MediaFileFragmentDoc } from '../../../../fragments/__generated__/file.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePostMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  content: Types.Scalars['String']['input'];
  selectedExistingMedia?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  newMedia?: Types.InputMaybe<Array<Types.Scalars['Upload']['input']> | Types.Scalars['Upload']['input']>;
  status: Types.Scalars['String']['input'];
  selectedUsers?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  publishAt?: Types.InputMaybe<Types.Scalars['Timestamp']['input']>;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'Post', id: string, content?: string | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string } }> | null, review?: { __typename?: 'PostReview', uuid: string, status: Types.PostReviewStatus, feedback?: string | null } | null } };


export const UpdatePostDocument = gql`
    mutation UpdatePost($id: ID!, $content: String!, $selectedExistingMedia: [ID!], $newMedia: [Upload!], $status: String!, $selectedUsers: [String!], $publishAt: Timestamp) {
  updatePost(
    data: {id: $id, content: $content, selectedExistingMedia: $selectedExistingMedia, newMediaFiles: $newMedia, status: $status, selectedUsers: $selectedUsers, publishAt: $publishAt}
  ) {
    id
    content
    mediaFiles {
      ...MediaFile
    }
    selectedUsers {
      user {
        id
      }
    }
    review {
      uuid
      status
      feedback
    }
  }
}
    ${MediaFileFragmentDoc}`;
export type UpdatePostMutationFn = Apollo.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *      selectedExistingMedia: // value for 'selectedExistingMedia'
 *      newMedia: // value for 'newMedia'
 *      status: // value for 'status'
 *      selectedUsers: // value for 'selectedUsers'
 *      publishAt: // value for 'publishAt'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, options);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;